export const LOCAL_CANVAS_LIFECYCLE_ECHO_TTL_MS = 5000;
